/**
 * Preferências de disposição, no browser.
 *
 * Mesma regra do voiceStorage: tudo em try/catch, porque num separador
 * privado o próprio acesso a `localStorage` lança — e esconder a lista de
 * membros não pode ser motivo para a app não abrir.
 */

const MEMBERS_KEY = 'tasca.members-visible';

export function loadMembersVisible(): boolean {
  try {
    return localStorage.getItem(MEMBERS_KEY) !== '0';
  } catch {
    return true;
  }
}

export function saveMembersVisible(visible: boolean): void {
  try {
    localStorage.setItem(MEMBERS_KEY, visible ? '1' : '0');
  } catch {
    /* sem armazenamento: a escolha dura esta sessão */
  }
}

const COLLAPSED_KEY = 'tasca.collapsed-categories';

/** Categorias fechadas, por id. Mesma regra: tudo em try/catch. */
export function loadCollapsed(): Set<string> {
  try {
    const raw = localStorage.getItem(COLLAPSED_KEY);
    return new Set(raw ? (JSON.parse(raw) as string[]) : []);
  } catch {
    return new Set();
  }
}

export function saveCollapsed(ids: Set<string>): void {
  try {
    localStorage.setItem(COLLAPSED_KEY, JSON.stringify([...ids]));
  } catch {
    /* sem armazenamento: as gavetas voltam a abrir na próxima sessão */
  }
}
